import { AfterViewChecked, Directive, ElementRef, HostListener, Input, NgModule, inject } from '@angular/core';

@Directive({ 
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[matchHeight]' })
export class MatchHeightDirective implements AfterViewChecked {
    private el = inject(ElementRef);

    // class name to match height
    @Input()
    matchHeight: string;

    constructor() {}

    ngAfterViewChecked() {
        // call our matchHeight function here
        this.matchHeights(this.el.nativeElement, this.matchHeight);
    }

    matchHeights(parent: HTMLElement, className: string) {
        // match height logic here
        if (!parent) {
            return;
        }

        // step 1: find all the child elements with the selected class name
        const children = parent.getElementsByClassName(className);

        if (!children) {
            return;
        }

        Array.from(children).forEach((x: HTMLElement) => {
            x.style.height = 'initial';
        });

        // step 2a: get all the child elements heights
        const itemHeights = Array.from(children).map(
            x => x.getBoundingClientRect().height
        );

        // step 2b: find out the tallest
        const maxHeight = itemHeights.reduce((prev, curr) => curr > prev ? curr : prev, 0);

        // step 3: update all the child elements to the tallest height
        Array.from(children).forEach(
            (x: HTMLElement) => (x.style.height = `${maxHeight}px`)
        );
    }

    @HostListener('window:resize')
    onResize() {
        // call our matchHeight function here
        this.matchHeights(this.el.nativeElement, this.matchHeight);
    }
}

@NgModule({
    imports: [MatchHeightDirective],
    exports: [MatchHeightDirective],
})
export class MatchHeightModule {}
